import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf, ViewEncapsulation, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as util from '../../../shared/services/util.service';
import { AbstractControl, ControlContainer, ControlValueAccessor, UntypedFormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocationType, ITransportOption, AppointmentType } from '@signal/asp-data-commons';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-toggle-location',
  templateUrl: './toggle-location.component.html',
  styleUrls: ['./toggle-location.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleLocationComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ToggleLocationComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class ToggleLocationComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() formControlName: string;
  @Input() allTransportOptions: ITransportOption[] = [];
  @Input() department:string;
  @Output() validateTransport:EventEmitter<boolean> = new EventEmitter();
  transportSelected: string;

  locationType: LocationType;
  isRemote: boolean;
  toggleView: boolean;
  private apptTransportByType: { [p: string]: any[] };
  transportsForSelectedType: any[] = [{ desc: 'test' }];
  //transportsForSelectedType:any;
  selectedTransportByType: any;
  additionalInfo:any;
  private control: AbstractControl;

  onChange: any = (value) => { };
  onTouched: any = () => { };

  constructor(@Optional() @Host() @SkipSelf()
  private readonly controlContainer: ControlContainer,
  private readonly translate: TranslateService,
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
   if (changes.hasOwnProperty('allTransportOptions') && changes.allTransportOptions.currentValue) {
      this.allTransportOptions = this.allTransportOptions.filter(x => x.isActive).map(opt => {
        if((this.department === AppointmentType.DELIVERY || this.department === AppointmentType.TEST_DRIVE) && opt.category === LocationType.DEALER && !opt.comments){
          return {...opt,comments : "Dealer"};
        }
        return opt
      })

      this.control = this.controlContainer.control.get(this.formControlName);
      
      this.toggleView = this.department === 'SERVICE'?false:!!this.allTransportOptions.find(x => x.category === LocationType.REMOTE);
      this.isRemote = (this.control.value === 'REMOTE');
    
      
      if(this.department === 'SERVICE') {
         this.toggleChangeForService();
      }
      else {
        /** to handle empty string control value for sales type appointment*/
        if(!this.control.value) {
          return;
        }

        this.toggleChangeForSales();
      }
    }
 }

 toggleChangeForService() {
    this.apptTransportByType = {"TransportOptions":this.allTransportOptions};
    if(this.apptTransportByType['TransportOptions'])
    {
      this.selectedTransportByType={
        ['TransportOptions']:this.apptTransportByType['TransportOptions'][0]
      }
    }
 
    if (this.transportSelected) {
      const initialTransport = this.allTransportOptions
        .find(ato => ato.id === this.transportSelected);
      if (initialTransport) {
        this.selectedTransportByType['TransportOptions'] = initialTransport;
      }
    }
    this.transportsForSelectedType = this.apptTransportByType['TransportOptions'];

    this.setTransportSelected(this.control.value);
 }

 toggleChangeForSales() {
  this.apptTransportByType = util.groupBy(this.allTransportOptions, 'category');
  if (this.apptTransportByType[LocationType.REMOTE]) {
    this.selectedTransportByType = {
      [LocationType.REMOTE]: this.apptTransportByType[LocationType.REMOTE][0],
      [LocationType.DEALER]: this.apptTransportByType[LocationType.DEALER][0]
    };
  } else {
    this.selectedTransportByType = {
      [LocationType.DEALER]: this.apptTransportByType[LocationType.DEALER][0]
    };
  }
  if (this.transportSelected) {
    const initialTransport = this.allTransportOptions
      .find(ato => ato.id === this.transportSelected);
    if (initialTransport) {
      this.isRemote = initialTransport.category === LocationType.REMOTE;
      this.locationType = this.isRemote ? LocationType.REMOTE : LocationType.DEALER;
      this.selectedTransportByType[this.locationType] = initialTransport;
    }
  }
  this.locationType = this.isRemote ? LocationType.REMOTE : LocationType.DEALER;
  this.transportsForSelectedType = this.apptTransportByType[this.locationType];
  this.setTransportSelected(this.control.value || this.selectedTransportByType[this.locationType].id);
 }

  ngOnInit(): void {


  }
   

  toggleLocationType() {
    this.isRemote = !this.isRemote;
    this.locationType = this.isRemote ? LocationType.REMOTE : LocationType.DEALER;
    this.transportsForSelectedType = this.apptTransportByType[this.locationType];
    this.setTransportSelected(this.selectedTransportByType[this.locationType].id);

  }

  onSelectingPickupLocation(transport: any) {
   const currentValue = this.department === 'SERVICE' ? 'TransportOptions' :this.locationType
    this.selectedTransportByType[currentValue]=transport;
   
   // this.selectedTransportByType[this.locationType] = transport;
   //this.selectedTransportByType['TransportOptions'] = transport;
   this.setTransportSelected(transport.id);
   if(transport.id === 'DELIVERY'){
     this.additionalInfo ="Please note, the customer has to visit the dealership to drop off his vehicle"
  }
  else if(transport.id === 'PICKUP')
  {
    this.additionalInfo ="Please note, the customer has to visit the dealership to pickup his vehicle after service"
  }
  else
  {
    this.additionalInfo ='';
  }
}

  setTransportSelected(value) {
  
    this.transportSelected = value;
    this.control.setValue(this.transportSelected);
    this.validateTransport.emit(value);
    this.onChange(this.transportSelected);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.transportSelected = value;
      this.isRemote = (value === 'REMOTE'); // TODO - check type instead of value
      this.locationType = this.isRemote ? LocationType.REMOTE : LocationType.DEALER;


      if (this.apptTransportByType && this.department!=='SERVICE'){
        this.transportsForSelectedType = this.apptTransportByType[this.locationType];
      }
      else if (this.apptTransportByType && this.department==='SERVICE'){
        this.transportsForSelectedType = this.apptTransportByType['TransportOptions'];
      }
    }
    
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  get value(): string {
    return this.control.value;
  }

  set value(value: string) {
    this.transportSelected = value;
    this.onChange(value);
    this.onTouched();
  }

  validate(_: UntypedFormControl) {
    return this.control?.valid ? null : { valid: false };
  }
  
  getTransport(name){
    if(name){
      if(name === "Rideshare" && this.translate.currentLang.split("-")[1] === "MX"){
        return this.translate.instant(`service.complimentaryTransportation`)
      }
      if((this.department === AppointmentType.TEST_DRIVE || this.department === AppointmentType.DELIVERY) && name === "Remote"){
        return this.translate.instant(`common.${name}`);
      }
      return this.translate.instant(`service.${name}`);
    }
  }

  getTranslation() {
     let apptTranslate = {
      "Test Drive" : this.translate.instant("serviceSchedule.testdrive"),
      "Service" : this.translate.instant("serviceSchedule.service"),
      "Delivery" : this.translate.instant("serviceSchedule.delivery"),
      "Learning" : this.translate.instant("serviceSchedule.learning")
    }
    return this.translate.instant(`otherTexts.yourAppointmentLocationWillBeAtAddressBelow`, {appointmentType:this.translate.instant(`${apptTranslate[this.department]}`).toLowerCase()});
  }

}
